import { useEffect, useState } from "react";
import HeaderWebMarketing from "../marketing/homes_headers";
import MobileNav from "../../components/header-mobile";
import MainSearch from "./main_search";
import FooterDark from "./min_dark_footer";
import SearchProjects from "../search";
import logoFull from "../../assets/logo-full.webp";


function LandingSearch({ initialDrawerOpen = false }) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(initialDrawerOpen);

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isDrawerOpen]);

    useEffect(() => {
        if (!isDrawerOpen) return;
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setIsDrawerOpen(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isDrawerOpen]);

    return (
        <div className={isDrawerOpen ? "drawer-open" : ""}>
            <div className="web-only">
                <HeaderWebMarketing hideRight={true} />
            </div>
            <div className="mobile-only">
                <MobileNav />
            </div>
            <MainSearch onOpenSearch={() => setIsDrawerOpen(true)} />
            <FooterDark />

            <div
                className={`search-drawer-overlay ${isDrawerOpen ? "is-open" : ""}`}
                onClick={() => setIsDrawerOpen(false)}
                aria-hidden={!isDrawerOpen}
            >
                <aside
                    className={`search-drawer-panel ${isDrawerOpen ? "is-open" : ""}`}
                    role="dialog"
                    aria-modal="true"
                    aria-label="Search projects"
                    onClick={(event) => event.stopPropagation()}
                >
                    <div className="search-drawer-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        {/* <span style={{ fontWeight: 'bold', fontSize: '1.1rem', marginLeft: '8px', color: '#000' }}>Conra Search</span> */}
                        <img src={logoFull} alt="Conra" className="sheet-title" style={{ margin: 0, height: '32px', width: 'auto' }} />
                        <button
                            type="button"
                            className="search-drawer-close"
                            onClick={() => setIsDrawerOpen(false)}
                            aria-label="Close search"
                            style={{ marginLeft: 'auto' }}
                        >
                            ×
                        </button>
                    </div>
                    <div className="search-drawer-content">
                        <SearchProjects onClose={() => setIsDrawerOpen(false)} />
                    </div>
                </aside>
            </div>
        </div>
    );
}

export default LandingSearch;
